import { UsuarioSistema } from './usuario-sistema.model';
import { NTECH_API } from './../app.api';
import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { ErrorHandler } from './../app.error-handler';

@Injectable()
export class UsuarioSistemaService {

    constructor(private http: Http) {

    }

    getUsuariosSistema(): Observable<UsuarioSistema[]> {
        return this.http.get(`${NTECH_API}/usuario-sistema`)
        .map(response => response.json())
        .catch(ErrorHandler.handleError);
    }

    getUsuarioSistemaById(id: string): Observable<UsuarioSistema> {
        return this.http.get(`${NTECH_API}/usuario-sistema/${id}`)
          .map(response => response.json())
          .catch(ErrorHandler.handleError);
    }

    getUsuarioSistemaByLogin(login: string): Observable<UsuarioSistema> {
        return this.http.get(`${NTECH_API}/usuario-sistema?Login=${login}`)
          .map(response => response.json())
          .catch(ErrorHandler.handleError);
    }

    gravarUsuarioSistema(usuarioSistema: UsuarioSistema): Observable<UsuarioSistema> {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');

        if ((usuarioSistema.Id !== undefined) && ((usuarioSistema.Id.length > 0) || (usuarioSistema.Id !== '0'))) {
            return this.http.put(`${NTECH_API}/usuario-sistema/${usuarioSistema.Id}`,
               JSON.stringify(usuarioSistema), new RequestOptions({headers: headers}))
            .map(response => response.json())
            .catch(ErrorHandler.handleError);
        } else {
            return this.http.post(`${NTECH_API}/usuario-sistema`, JSON.stringify(usuarioSistema), new RequestOptions({headers: headers}))
            .map(response => response.json())
            .catch(ErrorHandler.handleError);
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/usuario-sistema/usuario-sistema.service.ts